module.exports = __webpack_public_path__ + "static/media/icon_technology.6fa45f11.svg";